import React from 'react';
import Button from '@ramsey-design-system/button';
import { ChevronLeftIcon } from '@ramsey-design-system/icons/dist/ChevronLeftIcon';
import { ChevronRightIcon } from '@ramsey-design-system/icons/dist/ChevronRightIcon';
import { Navigation } from '../../lib/getNavigationMap';
import styles from './lesson-display.module.css';
import { ActionItem } from '../../types';
import { saveProgress } from '../../lib/learnClient';

type LessonNavigationProps = {
  navigation: Navigation;
  item: ActionItem;
};

function LessonNavigation({ navigation, item }: LessonNavigationProps) {
  if (item.template === 'survey') {
    return null;
  }

  const { previous, next, done } = navigation;

  return (
    <div className={styles.navigationContainer}>
      {previous ? (
        <Button
          href={previous}
          appearance="ghost"
          iconPosition="left"
          icon={ChevronLeftIcon}
          data-testid="previous-button"
          data-logger-element-id="Previous Action Item"
        >
          Previous
        </Button>
      ) : (
        <div />
      )}

      {next &&
        (item.body?.buttons?.length == 0 ? (
          <Button
            href={next}
            onClick={() => {
              saveProgress({
                course_id: item.course_id,
                lesson_id: item.lesson_id,
                action_id: item.id,
                data: { complete: true },
                template: item.template,
              });
            }}
            appearance="ghost"
            iconPosition="right"
            icon={ChevronRightIcon}
            data-testid="next-button-complete"
            data-logger-element-id="Next Action Item"
          >
            Next
          </Button>
        ) : (
          <Button
            href={next}
            appearance="ghost"
            iconPosition="right"
            icon={ChevronRightIcon}
            data-testid="next-button"
            data-logger-element-id="Next Action Item"
          >
            Next
          </Button>
        ))}

      {done && (
        <Button
          href={done.url}
          appearance="ghost"
          disabled={done.disabled}
          iconPosition="right"
          icon={ChevronRightIcon}
          data-testid="done-button"
          data-logger-element-id="Next Action Item"
        >
          Done
        </Button>
      )}
    </div>
  );
}

export default LessonNavigation;
